var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component, createRef } from "react";
import { filter, get } from "lodash";
import getId from "@irati/utils/id";
import { getResolvedMessage, injectIntl } from "@irati/utils/lang";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
import Expander, { ExpanderArrow } from "../Expander";
import { Container, Input } from "./styled";
import Option from "./styled/Option";
import PopupBox from "./styled/PopupBox";
var SortBy = /** @class */ (function (_super) {
    __extends(SortBy, _super);
    function SortBy(props) {
        var _this = _super.call(this, props) || this;
        _this.expander = createRef();
        _this.handleClick = function (option) {
            if (_this.expander.current) {
                _this.expander.current.close();
            }
            _this.props.onClick(option);
        };
        _this.handleOutsideClick = function (_a) {
            var _b;
            var target = _a.target;
            if (_this.expander.current) {
                if (!((_b = _this.expander.current.container.current) === null || _b === void 0 ? void 0 : _b.contains(target)) || !_this.expander.current.state.isExpanded) {
                    _this.expander.current.close();
                    return _this.setState({ inFocus: false });
                }
            }
            _this.setState({ inFocus: true });
        };
        _this.labelFromValue = function (value) {
            var _a = _this.props, options = _a.options, translateLabels = _a.translateLabels;
            var firstOption = filter(options, function (test) { return test.value === value; })[0];
            if (!translateLabels) {
                return get(firstOption, "label");
            }
            return getResolvedMessage(_this, "label", firstOption);
        };
        _this.shouldHighlightOption = function (value) { return value === _this.state.value; };
        _this.state = {
            value: props.value,
            inFocus: false
        };
        return _this;
    }
    SortBy.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.state.value) {
            this.setState({ value: nextProps.value });
        }
    };
    SortBy.prototype.UNSAFE_componentWillMount = function () {
        window.addEventListener("click", this.handleOutsideClick);
    };
    SortBy.prototype.componentWillUnmount = function () {
        window.removeEventListener("click", this.handleOutsideClick);
    };
    SortBy.prototype.render = function () {
        var _this = this;
        var _a = this.state, inFocus = _a.inFocus, value = _a.value;
        var _b = this.props, className = _b.className, id = _b.id, options = _b.options, icon = _b.icon;
        var arrow = function (props) { return React.createElement(ExpanderArrow, __assign({}, props)); };
        var header = function () {
            return (_this.props.header || (React.createElement(Flex, { alignItems: "center" },
                React.createElement(Icon, { marginLeft: 2, marginRight: 2, size: 16, icon: icon || IconTypes.filterUpAndDown }),
                React.createElement(Input, { bold: true, withEllipsis: true }, _this.labelFromValue(value)))));
        };
        return (React.createElement(Container, { className: "" + className, inFocus: inFocus },
            React.createElement(Expander, { fullWidth: true, id: id, ref: this.expander, Header: header, Arrow: arrow },
                React.createElement(PopupBox, null, options.map(function (option, i) { return (React.createElement(Option, { id: getId("option" + i, _this.props), key: option.value, addHighlight: _this.shouldHighlightOption(option.value), onClick: function () { return _this.handleClick(option); } },
                    React.createElement(Input, { bold: true, white: _this.shouldHighlightOption(option.value) }, getResolvedMessage(_this, "label", option)))); })))));
    };
    SortBy.defaultProps = {
        small: false,
        className: "",
        id: "",
        translateLabels: true,
        header: null
    };
    return SortBy;
}(Component));
export default injectIntl(SortBy);
